var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.featured && _vm.featured.id)?_c('div',{staticClass:"page-image",attrs:{"id":"featured-image"}},[_c('WpImage',{key:_vm.featured.id,attrs:{"image":_vm.featured,"size":_vm.size,"background":"","caption":"","styled-caption":"","cover":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }